import Link from 'next/link';

import { pastWebinars, SERIES_LENGTH, webinarPath } from './webinars';

/**
 * Strip that points at the most recent session. It ran on {event.date}, so the
 * offer is the recording, not a seat — the copy and the link both say so.
 */
export default function WebinarAnnouncement() {
  const event = pastWebinars[0];
  if (!event) return null;

  return (
    <aside aria-label="Webinar recording" className="bg-[#06264b] text-white">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between lg:px-8">
        <div>
          <p className="mb-1 text-xs font-bold uppercase tracking-[0.18em] text-[#e6ba50]">
            Recording available · Session {event.session} of {SERIES_LENGTH}
          </p>
          <p className="text-lg font-semibold">
            {event.title} {event.titleAccent}
          </p>
          <p className="mt-1 text-sm text-blue-100">
            This one already ran on {event.date} — watch the full {event.duration} back, free.
          </p>
        </div>
        <Link
          href={webinarPath(event)}
          className="inline-flex shrink-0 items-center justify-center gap-6 self-start rounded-lg bg-[#e6ba50] px-6 py-3 text-sm font-bold text-[#06264b] transition hover:bg-[#f3ce76] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white md:self-auto">
          Watch the recording <span aria-hidden="true">↗</span>
        </Link>
      </div>
    </aside>
  );
}
